import CountryPageTemplate from "../../components/country/CountryPageTemplate";
import { countryPages } from "../../data/countries";

function NewZealandPage() {
  return <CountryPageTemplate country={countryPages["new-zealand"]} />;
}

export default NewZealandPage;
